import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useMutation } from '@tanstack/react-query'
import React from 'react'

import ActionButton from '@/components/misc/ActionButton'
import { useInvalidateReferralLinksQueries } from '@/components/misc/ReferralLinksTable/hooks/useInvalidateReferralLinksQueries'
import { shareableLinkRowId } from '@/components/misc/ReferralLinksTable/lib/helpers'
import useNotyf from '@/hooks/useNotyf'
import { useShowGenericServerError } from '@/hooks/useShowGenericServerError'
import { faCopy } from '@/lib/fontAwesomePro/light'
import { highlightTableRowElement } from '@/lib/helpers/domHelpers'
import referralLinkService from '@/lib/services/referralLinkService'

interface Props {
  referralLinkId: number
}

const DuplicateButton: React.FC<Props> = ({ referralLinkId }) => {
  const notyf = useNotyf()
  const showGenericServerError = useShowGenericServerError()
  const invalidateReferralLinkQueries = useInvalidateReferralLinksQueries()

  const duplicateLinkMutation = useMutation({
    mutationFn: () => referralLinkService.duplicateLink(referralLinkId),
    onSuccess: async (newLink) => {
      await invalidateReferralLinkQueries()

      setTimeout(() => {
        const newRowElement = document.getElementById(
          shareableLinkRowId(newLink.id),
        )

        highlightTableRowElement(newRowElement)
      }, 200)

      notyf.success('Link duplicated successfully')
    },
    onError: showGenericServerError,
  })

  return (
    <ActionButton
      isProcessing={duplicateLinkMutation.isPending}
      isProcessingText="Duplicating"
      variant="outline-primary"
      className="flex w-full items-center justify-center sm:w-auto"
      size="sm"
      style={{ gap: '6px' }}
      onClick={() => duplicateLinkMutation.mutate()}
    >
      <FontAwesomeIcon icon={faCopy} />
      Duplicate
    </ActionButton>
  )
}

export default DuplicateButton
